


























import { Component, Vue, Prop } from 'vue-property-decorator';

import DetailsLayout from '@/components/car/DetailsLayout.vue';

@Component({
    name: 'DetailsPayment',
    components: {
        DetailsLayout,
    },
})
export default class DetailsPayment extends Vue {
    @Prop(Number) private totalPrice: number;
    @Prop(Number) private totalProducts: number;
}
